import store from "@/store";
import SettingsDashboard from "@/components/settings/SettingsDashboard.vue";
import MassiveSettingsDashboard from "@/components/settings/massive/MassiveSettingsDashboard.vue";

const canAccessSettings = () => store.getters.isAdmin;
const canAccessMassiveSettings = () => store.getters.isAdmin;

const settingsRoutes = [
  {
    path: "/settings",
    name: "settings",
    meta: {
      condition: canAccessSettings,
      redirectTo: { name: "home" },
    },
    component: SettingsDashboard,
  },
  {
    path: "/settings/massive",
    name: "settings-massive",
    meta: {
      condition: canAccessMassiveSettings,
      redirectTo: { name: "home" },
    },
    component: MassiveSettingsDashboard,
  },
];

export default settingsRoutes;
